<template>
  <tr>
    <td v-for="n in startDayOfWeek" :key="'empty-' + n"></td>
    <day
      :fetch-appointment-detail="false"
      v-for="day in weekDays"
      :key="day"
      :date="fullDate(currentYear, currentMonth, day)"
    />
  </tr>
</template>

<script>
import DayVue from "./Day.vue";
import { dateAndTimeMixin } from "../../../mixins/dateAndTimeMixin.js";
import { weekMixin } from "../../../mixins/weekMixin.js";

export default {
  mixins: [dateAndTimeMixin, weekMixin],
  components: {
    day: DayVue
  }
};
</script>
